import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { ModalService } from '../../../core/services/modal.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-choice-possibility-list',
  templateUrl: './choice-possibility-list.component.html',
  styleUrls: ['./choice-possibility-list.component.css']
})
export class ChoicePossibilityListComponent implements OnInit {
    choiceKeyno;

    public setting?: Setting;

    public itemsListChoicePossibilities: Item[] = [];

    public grid?: GridOptions;

    public saving = false;

    public productNameChoiceButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.setting!.prod_keyno_choice ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.choiceKeyno = this.stateService.getStateParams()['choice_keyno'];
    }

    private async loadSetting() {
        if (!!this.choiceKeyno) {
            this.setting = (await this.datatask.Post(1215, { choice_keyno: this.choiceKeyno }))[0];
        }
    }

    private async loadChoicePossibilities() {
        if (!!this.setting) {
            this.itemsListChoicePossibilities = await this.datatask.Post(1216, this.setting);
        }
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('w_choicepossibilitylist_grid')
                    .setLoadDataFunction({
                        method: 3620,
                        parameters: this.setting
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    public async saveChanges() {
        if (!!this.setting) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1818, {
                    choice_keyno: this.setting.choice_keyno,
                    records: this.itemsListChoicePossibilities.map((item) => ({
                        item_id: item.item_id,
                        item_is_selected: item.item_is_selected
                    }))
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public onTabChange() {
        if (!!this.setting) this.loadChoicePossibilities();
    }

    private async init() {
        await this.loadSetting();
        this.loadChoicePossibilities();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    choice_keyno: number;
    choice_belong_to_prod_id: string;
    choice_belong_to_prod_name: string;
    stdchoice_prod_id: string;
    lock_possibilities: string;
    prod_id_choice: string;
    prod_name_choice: string;
    page_heading: string;
    prod_id: string;
    filtervalue: string;
    gb_choicepossibilitylist_type: string;
    choice_restrictpossibility_info: string;
    prod_keyno_choice: string;
    restrictpossibility: string;
}
